<template>
  <div>
    <table class='table_flower' v-viewer>
      <tr>
        <th>
          流水号
        </th>
        <td>
          {{form.applicationNo}}
        </td>
        <th>
          申请业务
        </th>
        <td>
          {{form.applicationTypeText}}
          积分有效期内变更居住地址
        </td>
      </tr>
      <tr>
        <th>
          单位名称
        </th>
        <td>
          {{form.enterpriseName}}
        </td>
        <th>
          社会统一信用代码
        </th>
        <td>
          {{form.enterpriseCode}}
        </td>
      </tr>
      <tr>
        <th>
          人事姓名
        </th>
        <td>
          {{form.personnelName}}
        </td>
        <th>
          人事身份证号
        </th>
        <td>
          {{form.personnelIDCardNo}}
        </td>
      </tr>
      <tr>
        <th>
          人事联系方式
        </th>
        <td colspan="3">
          {{form.personnelPhone}}
        </td>
      </tr>
      <tr>
        <th>
          申请人身份证人像面
        </th>
        <td>
          <img :src="this.$baseURL + '/file/preview/'+form.applicantIDCardFrontGuid" fit="fill" width="100px" height="100px" />
        </td>
        <th>
          申请人身份证国徽面
        </th>
        <td>
          <img :src="this.$baseURL + '/file/preview/'+form.applicantIDCardBackGuid" fit="fill" width="100px" height="100px" />
        </td>
      </tr>
      <tr>
        <th>
          申请人姓名
        </th>
        <td>
          {{form.applicantName}}
        </td>
        <th>
          申请人身份证号
        </th>
        <td>
          {{form.applicantIDCardNo}}
        </td>
      </tr>
      <tr>
        <th>
          申请人联系方式
        </th>
        <td colspan="3">
          {{form.applicantPhone}}
        </td>
      </tr>
      <tr>
        <th>
          申请人居住证正面
        </th>
        <td>
          <img :src="this.$baseURL + '/file/preview/'+form.applicantResidencePermitFrontGuid" fit="fill" width="100px" height="100px" />
        </td>
        <th>
          居住证有效期
        </th>
        <td colspan="3">
          {{form.applicantResidencePermitExpiryDateText}}
        </td>
        <!-- <th>
            上传申请人居住证反面
          </th>
          <td>
            <img :src="this.$baseURL + '/file/preview/'+form.applicantResidencePermitBackGuid" fit="fill" width="100px" height="100px" />
          </td> -->
      </tr>
      <!-- <tr>
          <th>
            居住证有效期
          </th>
          <td colspan="3">
            {{form.applicantResidencePermitExpiryDate}}
          </td>
        </tr> -->
      <tr>
        <th>
          居住证地址
        </th>
        <td colspan="3">
          {{form.applicantResidencePermitAddress}}
        </td>
      </tr>
      <tr>
        <th>
          是否变更户籍地址
        </th>
        <td colspan="3">
          {{form.isChangeDomicileAddress?"是":'否'}}
        </td>
      </tr>
      <tr v-if="form.isChangeDomicileAddress">
        <th>
          变更后的户籍地
        </th>
        <td>
          {{form.changeDomicileAddress}}
        </td>
        <th>
          变更后的户籍地材料
        </th>
        <td>
          <div class="_link" v-for="item in form.changeDomicileAddressFileGuidListPreview" @click="handlePreview(item)" :key="item.guid">
            <Icon :type="item.name | fileType" />
            {{item.name}}
          </div>
          <span class='_noLink' v-if="form.changeDomicileAddressFileGuidListPreview.length<1">无</span>
        </td>
      </tr>
      <tr>
        <th>
          其他材料
        </th>
        <td colspan="3">
          <div class="_link" v-for="item in form.otherFileGuidListPreview" @click="handlePreview(item)" :key="item.guid">
            <Icon :type="item.name | fileType" />
            {{item.name}}
          </div>
          <span class='_noLink' v-if="form.otherFileGuidListPreview.length<1">无</span>
        </td>
      </tr>

      <tr>
        <th>
          提交时间
        </th>
        <td>
          {{ form.submitTimeText}}
        </td>
        <th>
          状态
        </th>
        <td>
          {{ form.statusText}}
        </td>
      </tr>

    </table>
  </div>
</template>
<script>
export default {
  props: { form: Object },
  methods: {
    handlePreview(url) {
      this.$emit('handlePreview', url)
    },
  },
}
</script>